<prlw-basis-counter-label-ui
  [currentProductGroup]="currentProductGroup$ | async"
  [preloaderActive]="preloaderActive$ | async"
  [totalShipmentsForCurrentProductGroupCount]="totalShipmentsForCurrentProductGroupCount$ | async"
  (eventOpenManageOverlay)="handleOpenManageOverlay()"
></prlw-basis-counter-label-ui>
